<template>
  <table class="mds-data-table change-status__table">
    <thead class="mds-data-table__header">
      <tr class="mds-data-table__row">
        <th class="mds-data-table__header-cell" width="44" scope="col"></th>
        <th class="mds-data-table__header-cell" scope="col" :colspan="expanded ? 2 : 1">
          <div class="mds-data-table__header-cell-inner mds-data-table__header-cell--left">
            <slot name="title"></slot>
          </div>
        </th>
        <th class="mds-data-table__header-cell" width="25%" scope="col">
          <div class="mds-data-table__header-cell-inner mds-data-table__header-cell--left">
            {{ columns[0] }}
          </div>
        </th>
        <th class="mds-data-table__header-cell" width="20%" scope="col">
          <div class="mds-data-table__header-cell-inner mds-data-table__header-cell--left">
            {{ columns[1] }}
          </div>
        </th>
        <th class="mds-data-table__header-cell" width="15%" scope="col">
          <div class="mds-data-table__header-cell-inner mds-data-table__header-cell--left">
            {{ columns[2] }}
          </div>
        </th>
      </tr>
    </thead>
    <tbody class="mds-data-table__body">
      <slot></slot>
    </tbody>
  </table>
</template>
<script>
export default {
  name: 'change-status-table',
  props: {
    columns: {
      type: Array,
      default: [],
      validator: (value) => {
        return Array.isArray(value) && value.length >= 3;
      },
    },
    expanded: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
};
</script>
<style lang="scss">
.change-status__table {
  thead .mds-data-table__header {
    border: none;
  }
  thead .mds-data-table__header-cell-inner {
    @include mds-body-text-s();
    color: $mds-color-black;
    font-weight: $mds-font-weight-bold;
  }
  tbody .group-begin .mds-data-table__cell {
    padding-top: $mds-space-inset-2-x;
  }
  tbody .group-end .mds-data-table__cell {
    padding-bottom: $mds-space-inset-2-x;
  }
  tbody .mds-data-table__row.group-end {
    border-bottom: 1px solid $mds-color-neutral-90;
  }
  tbody .mds-data-table__row .mds-data-table__cell {
    border-top: 0;
  }
  tbody .mds-data-table__row .mds-data-table__cell:first-child {
    padding-left: $mds-space-inset-half-x;
  }
  .mds-data-table__cell {
    vertical-align: top;
  }
}
</style>
